import { useRouteError } from "react-router-dom";

const Error = () => {
    const err = useRouteError();
    return (
        <main role="alert">
            <h1>Oops</h1>
            <h2>Something went wrong</h2>
            {(err?.status || err?.statusText) && (
                <p>
                    Status: {err?.status} — {err?.statusText}
                </p>
            )}
            <a href="/">back to main page</a>
        </main>
    )
}

export default Error;